import React from 'react';
import cn from 'classnames';
import { CartItemType } from '@base/cart/interface';
import styles from './cartMenu.module.less';
import CartItemImage from '@base/cart/CartItemImage';
import CartItemName from '@base/cart/CartItemName';
import CartItemAttrs from '@base/cart/CartItemAttrs';
import CartItemPrice from '@base/cart/CartItemPrice';
import CartItemQty from '@base/cart/CartItemQty';
import { CartType } from '@base/cart/useCart';
import { isBonusProduct } from 'base/utils/product';
import CartItemCheckbox from '@base/cart/CartItemCheckbox';
import { ICartGroup } from 'mod/cart/interface';
import Iconfont from '@base/lib/Iconfont';
import DeliveryTime from '@base/snippets/DeliveryTime'
import { ProdGifts } from '@app/common/ProdGifts';

declare interface IProps {
    item: CartItemType;
    index: number;
    onChangeItemNum: (itemId: string, num: number) => void;
    onDeleteItem: (itemId: string, isOos: boolean) => void;
    isBatchList: boolean;
    loadCart: CartType['loadCart'];
    group: ICartGroup;
    editable: boolean;
    showItemCheckbox?: boolean;  // 展示item checkbox选项
}

const CartItem: React.FC<IProps> = (props) => {
    const {
        item,
        index,
        onChangeItemNum,
        onDeleteItem,
        isBatchList,
        loadCart,
        group,
        editable,
        showItemCheckbox = true
    } = props

    const isOos = item.stockNum === 0;
    const isBonus = isBonusProduct(item);

    return (
        <div className={cn(
            'flex flex-wrap',
            styles.item,
            { [styles['item-oos']]: item.stockNum === 0 }
        )}>
            <div
                className={styles['col-checkbox']}
                style={{ visibility: isBonus || group.forceBatchOperate ? 'hidden' : 'visible' }}
            >
                {(!isBatchList || editable) && showItemCheckbox && (
                    <CartItemCheckbox
                        className={styles['checkbox-common']}
                        item={item}
                        batchActive={false}
                    />
                )}
            </div>
            <div className={styles['col-picture']}>
                <CartItemImage
                    item={item}
                    width={120}
                    group={group}
                />
            </div>

            <div className="flex-1">
                <div className={cn(styles.info, 'flex flex-vertical')}>
                    <div className="flex-1">
                        <DeliveryTime deliveryTime={item.deliveryTime} className={styles['delivery-time']}/>

                        <CartItemName className={styles.name} item={item}/>
                        <CartItemAttrs className={styles.attrs} item={item}/>
                    </div>
                    <div className="flex flex-justify">
                        <CartItemPrice group={group} className={styles.prices} item={item} loadCart={loadCart}/>
                        <div className={cn(styles['item-options'], 'relative')}>
                            <CartItemQty
                                className={styles.qty}
                                item={item}
                                onChangeItemNum={onChangeItemNum}
                                changeable={!group.forceBatchOperate && editable}
                            />
                            {editable && (
                                <button
                                    type="button"
                                    className={cn('btn-no-style', styles['btn-delete'])}
                                    onClick={() => onDeleteItem(item.id, isOos)}
                                    disabled={item.isChangingQty}
                                >
                                    <Iconfont className={'icon-ashbin'}/>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ProdGifts gifts={item.giftItemList} className={styles.gifts}/>
        </div>
    )
}

export default React.memo(CartItem);
